/* eslint-disable import/named */
/* eslint-disable no-console */
import { push } from 'react-router-redux';
import { notification } from 'antd';
import { delay } from 'redux-saga';
import { put, takeLatest, select } from 'redux-saga/effects';
import { setNotification } from 'utils';
import {
    loadMachinesRes,
    loadMachinesErr,
    addNewMachineRes,
    addNewMachineErr,
    loadEditableMachineRes,
    editMachineRes,
    editMachineErr,
    deleteMachineRes,
    deleteMachineErr,
} from '../actions/machineAction';
import {
    getMachinesApi,
    addNewMachineApi,
    editMachineApi,
    deleteMachineApi,
} from '../api/machineApi';
import {
    LOAD_MACHINES,
    ADD_NEW_MACHINE,
    LOAD_EDITABLE_MACHINE,
    EDIT_MACHINE,
    DELETE_MACHINE,
} from '../types/machineTypes';

// const getMachine = state => state.machine;
const getLayout = state => state.layout;

// L O A D   M A C H I N E S
function* loadMachineSaga() {
    try {
        const result = yield getMachinesApi();
        if (result.status === 200) {
            yield put(loadMachinesRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(loadMachinesErr());
    }
}

export function* loadMachineWatcher() {
    yield takeLatest(LOAD_MACHINES, loadMachineSaga);
}
// L O A D   M A C H I N E S

// A D D   N E W   M A C H I N E
function* addNewMachineSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'machine.notification.newMachineAddedSuccess';

    try {
        const result = yield addNewMachineApi(action.data);

        if (result.status === 202) {
            yield put(addNewMachineRes(true, false));

            yield put(push('/pp/machines/'));

            yield put(addNewMachineRes(false, true));
            yield delay(1000);
            yield put(addNewMachineRes(false, false));

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(addNewMachineErr(error.message));
        }
    } catch (e) {
        yield put(addNewMachineErr());
        setNotification('error', locale, 'global.error', 'machine.notification.addingNewMachineError');
        console.log(e);
    }
}

export function* addNewMachineWatcher() {
    yield takeLatest(ADD_NEW_MACHINE, addNewMachineSaga);
}
// A D D   N E W   M A C H I N E

// L O A D   E D I T A B L E   M A C H I N E
function* loadEditableMachineSaga(action) {
    try {
        const param = {
            filter: JSON.stringify({
                _id: action.id,
            }),
        };

        const resultMachine = yield getMachinesApi(param);

        if (resultMachine.data.hits.length === 0) {
            notification.error({
                message: 'Error',
                description: 'Machine does not exist',
            });

            yield put(push('/404'));
            yield put(loadMachinesErr());
        } else {
            yield put(loadEditableMachineRes(resultMachine.data.hits[0]));
        }
    } catch (e) {
        console.log(e);
        yield put(loadMachinesErr());
    }
}

export function* loadEditableMachineWatcher() {
    yield takeLatest(LOAD_EDITABLE_MACHINE, loadEditableMachineSaga);
}
// L O A D   E D I T A B L E   M A C H I N E

// E D I T   M A C H I N E
function* editMachineSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    try {
        const result = yield editMachineApi(action.data);

        if (result.status === 202) {
            yield put(push('/pp/machines/'));
            yield put(editMachineRes(result));
            yield delay(1000);
            setNotification('success', locale, 'global.success', 'machine.notification.machineEditedSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(editMachineErr(error.message));
        }
    } catch (e) {
        yield put(editMachineErr());
        setNotification('error', locale, 'global.error', 'machine.notification.machineEditedError');
        console.log(e);
    }
}

export function* editMachineWatcher() {
    yield takeLatest(EDIT_MACHINE, editMachineSaga);
}
// E D I T   M A C H I N E

// D E L E T E   M A C H I N E
function* deleteMachineSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    try {
        const result = yield deleteMachineApi(action.data);

        if (result.status === 202) {
            yield put(push('/pp/machines/'));
            yield put(deleteMachineRes(result));
            setNotification('success', locale, 'global.success', 'machine.notification.machineDeletedSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(deleteMachineErr(error.message));
        }
    } catch (e) {
        yield put(deleteMachineErr());
        setNotification('error', locale, 'global.error', 'machine.notification.machineDeletedError');
        console.log(e);
    }
}

export function* deleteMachineWatcher() {
    yield takeLatest(DELETE_MACHINE, deleteMachineSaga);
}
// D E L E T E   M A C H I N E
